import React from 'react';
import PropTypes from 'prop-types';

const WriteLoader = ({ ...props }) => {
  const loaderDisplay = props.isLoading ? 'flex' : 'none';

  const loaderStyle = {
    display: loaderDisplay
  };

  return <div style={loaderStyle} className='write-loader'>
    {/* <i className='cancel-button icon-cancel' onClick={() => props.toggleLoader(false)}>X</i> */}
    <i className='cancel-button material-icons material-icons-close' onClick={() => props.toggleLoader(false)} />
    <div className='site-spinner' />
  </div>;
};

WriteLoader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  toggleLoader: PropTypes.func.isRequired
};

export default WriteLoader;
